import { useQuery } from '@tanstack/react-query';
import { fetchDashboard, fetchProgress } from '../api/dashboard';

/**
 * Hook to fetch and cache dashboard data
 * Refetches when window regains focus
 */
export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: fetchDashboard,
    staleTime: 30000, // Consider data fresh for 30 seconds
    refetchOnWindowFocus: true,
    retry: 2
  });
};

/**
 * Hook to fetch and cache progress data (30-day XP history)
 */
export const useProgress = () => {
  return useQuery({
    queryKey: ['progress'],
    queryFn: fetchProgress,
    staleTime: 60000, // Consider data fresh for 1 minute
    refetchOnWindowFocus: true,
    retry: 2
  });
};
